// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3jttI{display:-ms-flexbox;display:flex;height:100vh;scrollbar-gutter:stable;width:100%}@media (min-width:1024px){._3jttI{-ms-flex-direction:row;flex-direction:row}}._3jttI svg path{vector-effect:non-scaling-stroke}._2E29O{-ms-flex:1 0;flex:1 0;height:100%;max-width:100%;overflow-y:auto;padding:6rem}@media (min-width:1280px){._2E29O{padding:3.2rem 2.4rem 4.8rem}}", ""]);
// Exports
exports.locals = {
	"root": "_3jttI",
	"content": "_2E29O"
};
module.exports = exports;
